<template>
  <!--  Top Nav -->
  <nav class="bg-green-500 h-32 p-4 text-white">
    <!-- <h1 class="text-xl">پرسشنامه</h1> -->
    <!-- <div class="mt-1" @click="cityModal = true">
      <div v-if="province">
        <span>{{ province }}</span>
        -
        <span>{{ city }}</span>
      </div>
      <div v-else>انتخاب شهر و استان</div>
    </div> -->
  </nav>

  <!--  Header Card -->
  <div class="bg-white rounded-lg w-3/4 -mt-10 mx-auto p-5 text-center">
    <h1 class="text-lg">پرسشنامه جدید</h1>
    <div v-if="province" class="text-sm mt-4">
      <span>{{ province }}</span>
      -
      <span>{{ city }}</span>
    </div>
    <div v-else>
      <Button class="w-full mt-4" @click="cityModal = true" >انتخاب شهر و استان</Button>
    </div>
    <router-link to="/survey/shop-info">
      <Button class="w-full mt-4">شروع</Button>
    </router-link>
  </div>

  <router-view></router-view>

  <!--  Main Image -->
  <div class="p-4 mt-10" v-if="$route.name === 'Home'">
    <img src="../assets/img/tabarok_logo.png" alt="" />
  </div>

  <!--  City Modal -->
  <transition name="fade">
    <div
      class="absolute flex items-center justify-center w-full h-screen top-0 bg-gray-500 bg-opacity-60"
      v-if="cityModal"
      @click="cityModal = false"
    >
      <div class="bg-white shadow w-3/4 rounded-lg p-4" @click.stop>
        <h1 class="text-center">انتخاب شهر و استان</h1>
        <hr class="my-4" />

        <label class="text-sm mr-1">استان</label>
        <select
          class="w-full bg-gray-100 rounded-lg p-2 mt-1 mb-4"
          v-model="province"
        >
          <option value="خراسان رضوی">خراسان رضوی</option>
        </select>

        <label class="text-sm mr-1">شهر</label>
        <select class="w-full bg-gray-100 rounded-lg p-2 mt-1" v-model="city">
          <option value="مشهد">مشهد</option>
        </select>
        <label class="text-sm mr-1">شماره موبایل</label>
        <Input v-model="mobile" />

        <Button class="w-full mt-5" @click="submitCity">ثبت</Button>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from "../components/Button";
import Input from "../components/Input";

export default {
  name: "Home",
  components: { Button, Input },
  data() {
    return {
      cityModal: false,
      city: this.$store.state.city,
      province: this.$store.state.province,
      mobile: this.$store.state.mobile,
    };
  },
  methods: {
    validatePhoneNumber() {
      let result = true;
      if (!this.mobile) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "لطفا شماره همراه خود را وارد نمایید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });

        result = false;
      } else if (this.mobile.length !== 11) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "شماره همراه باید 11 رقم باشد",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });

        result = false;
      } else if (this.mobile.substr(0, 2) !== "09") {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "شماره همراه باید با 0 شروع شود",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
        result = false;
      }
      return result;
    },
    submitCity() {
      let provinceCity = {
        province: this.province,
        city: this.city,
        mobile: this.mobile,
      };
      if (this.city === "" || this.province === "") {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "لطفا ابتدا شهر و استان را انتخاب کنید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      } else if (
        this.validatePhoneNumber() &&
        this.city !== "" &&
        this.province !== ""
      ) {
        this.$store.dispatch("setCity", provinceCity);
        this.cityModal = false;
      }
    },
    startSurvey() {
      if (this.city === "" || this.province === "") {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "لطفا ابتدا شهر و استان را انتخاب کنید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      } else if (
        this.validatePhoneNumber() &&
        this.city !== "" &&
        this.province !== ""
      ) {
        this.$router.push("/");
      }
    },
  },
};
</script>
